export default {
  verizon: {
    id: 'product_page_telco_calculator_advertisement_verizon',
    defaultMessage: 'Verizon',
  },
  tmobile: {
    id: 'product_page_telco_calculator_advertisement_tmobile',
    defaultMessage: 'T-Mobile',
  },
  att: {
    id: 'product_page_telco_calculator_advertisement_att',
    defaultMessage: 'AT-T',
  },
}
